<template>
    <div class="work-weixin-auth">
        <!-- https://weixin.qiyehuo.com/ -->
        <upfile name="上传图片" :many="1" action="https://weixin.qiyehuo.com/api/common_upload_get_data" :mul="false"
            bus='abcde' acc="" :acce="[]" />
        <el-upload action="" :headers="headers" ref="uploadMutiple" :show-file-list="false" :http-request="upload">
            <el-tooltip class="item" effect="dark" content="导出服务开始时间和结束时间" placement="top">
                <el-button type="warning" size="mini">导入</el-button>
            </el-tooltip>
        </el-upload>
        <div>
            <el-button type="warning" size="mini" @click="exportFin">财务登记表导出</el-button>
        </div>
        <div>
            <el-button type="warning" size="mini" @click="exportPubDemand">公众号用户需求导出</el-button>
        </div>
        <div>
            <el-button type="warning" size="mini" @click="exportUserReg">注册吧用户关联所属业务导出</el-button>
        </div>
        <div>
            <el-button type="warning" size="mini" @click="openUrl">打开</el-button>
        </div>
        <div>
            <el-button type="warning" size="mini" @click="openIframe">打开iframe</el-button>
        </div>
        <div id="iframe"></div>
    </div>
</template>
<script>
import upfile from '../../common/UpFile.vue'
export default {
    name: 'WorkWeiXinAuth',
    components: { upfile },
    data() {
        return {
            headers: { Authorization: localStorage.token },
        }
    },
    methods: {
        openIframe() {
            var ele = document.createElement('iframe')
            // ele.src='https://admin.qiyehuo.com'
            ele.src='https://sh.jyfwyun.com/search/item'
            ele.width='100%'
            ele.height= '900rem'
            document.getElementById('iframe').appendChild(ele)
        }, 
        openUrl() {
            window.open('http://wx.qyh.com/api/third_work_weixin_redirect_uri','_self')
        },
        upload(param) {
            const formData = new FormData()
            formData.append('file', param.file)
            // 导出服务时间
            // this.$axios.post('api/common_upload_get_data', formData, { responseType: 'blob' }).then(({ data }) => {
            // 筛选业务
            // this.$axios.post('api/common_upload_filter_hero', formData, { responseType: 'blob' }).then(({ data }) => {
            // 导入公司
            this.$axios.post('api/common_upload_company_name', formData, { responseType: 'blob' }).then(({ data }) => {
            // 导入财税工厂
            // this.$axios.post('api/common_upload_store_finance_taxation', formData, { responseType: 'blob' }).then(({ data }) => {
            // 导出公司名称和ID
            // this.$axios.post('api/common_upload_import_company_info', formData, { responseType: 'blob' }).then(({ data }) => {
            // 导出单品表
            // this.$axios.post('api/mytest', formData, { responseType: 'blob' }).then(({ data }) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let objectUrl = window.URL.createObjectURL(blob)
                let link = document.createElement('a')
                link.href = objectUrl
                link.download = '系统单品表.xlsx'
                link.click()
                setTimeout(function () {
                    window.URL.revokeObjectURL(objectUrl)
                }, 10)
            }).catch(response => {
                console.log('异常处理')
            })
        },
        redirectSelf() {
            this.$axios.get('api/third_work_weixin_redirect_uri').then(({ data }) => {
                if (data.code === 200) {
                    window.open(data.url)
                }
            }).catch()
        },
        exportFin() {
            this.$axios.post('api/mytest', {}, { responseType: 'blob' }).then(({ data }) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let objectUrl = window.URL.createObjectURL(blob)
                let link = document.createElement('a')
                link.href = objectUrl
                link.download = '财务登记表过期时间2022年12月31日之前的公司.xlsx'
                link.click()
                setTimeout(function () {
                    window.URL.revokeObjectURL(objectUrl)
                }, 10)
            }).catch()
        },
        exportPubDemand() {
            this.$axios.post('api/api3_no_token/export_pub_demand', {}, { responseType: 'blob' }).then(({ data }) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let objectUrl = window.URL.createObjectURL(blob)
                let link = document.createElement('a')
                link.href = objectUrl
                link.download = '用户需求.xlsx'
                link.click()
                setTimeout(function () {
                    window.URL.revokeObjectURL(objectUrl)
                }, 10)
            }).catch()
        },
        exportUserReg() {
            this.$axios.post('api/api3_no_token/export_user_reg_now', {}, { responseType: 'blob' }).then(({ data }) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let objectUrl = window.URL.createObjectURL(blob)
                let link = document.createElement('a')
                link.href = objectUrl
                link.download = '注册吧小程序用户.xlsx'
                link.click()
                setTimeout(function () {
                    window.URL.revokeObjectURL(objectUrl)
                }, 10)
            }).catch()
        },
    },
    mounted() {
        // this.redirectSelf()
    }
}
</script>
<style scoped>
.work-weixin-auth {
    /* margin-left: 1.25rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/ysy/WorkWeiXinAuth.vue